const formatter = new Intl.NumberFormat("es-AR", {
  style: "currency",
  currency: "ARS",
});
const formatMoney = (amount?: number | bigint | null) => formatter.format(amount ?? 0);

export { formatMoney };
